import { EmptyListContent } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { FC } from "react";
import notFoundAnimation from "./assets/not-found-animation.json";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

interface TicketDetailsNotFoundStateProps {
  onClose: () => void;
}

export const TicketDetailsNotFoundState: FC<
  TicketDetailsNotFoundStateProps
> = ({ onClose }) => {
  const { t } = useTranslations();

  return (
    <EmptyListContent
      type="custom"
      className="w-[500px]"
      customImg={
        <Lottie
          options={{ animationData: notFoundAnimation }}
          width={150}
          height={150}
        />
      }
      customTitle={t({
        id: "client-support-page.ticket-not-found-title",
        defaultMessage: "Ticket was not found",
      })}
      customSubtitle={t({
        id: "client-support-page.ticket-not-found-description",
        defaultMessage: "Sorry, we cant find the ticket you're looking for",
      })}
      customButton={{
        text: t({
          id: "common.okay",
          defaultMessage: "Okay",
        }),
        onClick: onClose,
        iconEnd: <ArrowRightIcon />,
        className: "w-[200px]",
      }}
    />
  );
};
